
import {View} from 'backbone';
import template from 'common-views/close-form-confirm.ejs';
import constants from 'Constants.js';
import $ from 'jquery';
import listService from "../../service/ListService";

class CloseFormConfirmationModalView extends View {
    initialize(opts){
        super.initialize(opts);
        if (!this.model.get('subtitle')) {
            this.model.set('subtitle',  'Close');
        }
        if (!this.model.get('height')) {
            this.model.set('height',  300);
        }
        if (!this.model.get('width')) {
            this.model.set('width',  500);
        }
        $('body').append(this.$el);
    }

    render(){
        const _self = this;
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();
            listService.isUndoRedoEnabled = false;

            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: this.model.get('height'),
                width: this.model.get('width'),
                modal: true,
                resizable: false,
                create: function () {
                    $(this).closest('.ui-dialog').on('keydown', function (ev) {
                        if (ev.keyCode === $.ui.keyCode.ESCAPE) {
                            _self.closeModal();
                        }
                    });
                },
                buttons: [
                    {
                        text: 'Yes',
                        'class':'btn-select-item',
                        click: () => {
                            resolve('Yes');
                            _self.closeModal();
                        }
                    },
                    {
                        text: 'No',
                        'class':'btn-select-item',
                        click: () => {
                            resolve('No');
                            _self.closeModal();
                        }
                    },
                    {
                        'text': 'Cancel',
                        'class':'leftButton',
                        click: () => {
                            resolve('Cancel');
                            _self.closeModal();
                        }
                    }
                ]
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        });
    }
    closeModal(){
        listService.isUndoRedoEnabled = true;
        $( constants.DIALOG_ID ).dialog("destroy").remove();
        this.remove();

        listService.isSaveDialogOpened = false;
    }
}

export default CloseFormConfirmationModalView;